import { Button } from '@material-ui/core'
import { FormTextField } from '@/components/TextField/FormTextField'

import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { ErrorMessage as Error } from '@hookform/error-message'

import { useState } from 'react'
import {
  Logo,
  Link,
  Subtitle,
  FormTitle,
  ErrorMessage,
  YupError,
} from './styles'
import Router from 'next/router'

import schema, {
  RecoveryPasswordFormData,
} from '@/lib/validation/PasswordRecovery'
import { usePasswordRecoveryMutation } from '@/lib/api/mutations/usePasswordRecoveryMutation'
import { Routes } from '@/lib/models/enums/Routes.enum'

const PasswordRecoveryView: React.FC = () => {
  const [errorMessage, setErrorMessage] = useState(null)
  const [requestPasswordRecovery, isMutationLoading] =
    usePasswordRecoveryMutation()

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<RecoveryPasswordFormData>({
    resolver: yupResolver(schema),
    mode: 'onBlur',
  })

  async function onSubmit(data: RecoveryPasswordFormData) {
    requestPasswordRecovery({ email: data.email })
      .then(response => {
        Router.push(Routes.PASSWORD_RECOVERY_SUCESS_ROUTE)
        return response
      })
      .catch(e => {
        const errorMessage = e?.response?.data?.error?.message
        errors.email = errorMessage
        setErrorMessage(errorMessage)
      })
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Logo width="10rem" height="auto" />
      <FormTitle>Esqueceu sua senha?</FormTitle>
      {errorMessage && (
        <ErrorMessage severity="error" variant="outlined">
          {errorMessage}
        </ErrorMessage>
      )}
      <Subtitle>
        Não se preocupe! Insira o seu e-mail de cadastro e te enviaremos as
        instruções.
      </Subtitle>
      <FormTextField
        name="email"
        control={control}
        label="E-mail"
        variant="outlined"
        id="email"
        error={Boolean(errors?.email)}
        fullWidth
      />
      <Error errors={errors} name="email" as={<YupError />} />
      <Button
        variant="contained"
        color="primary"
        type="submit"
        disabled={isMutationLoading}
      >
        Confirmar
      </Button>
      <Link href={Routes.LOGIN}>Voltar para Login</Link>
    </form>
  )
}

export default PasswordRecoveryView
